export const LOOKUP_START_LOADING = "LOOKUP_START_LOADING";
export const LOOKUP_END_LOADING = "LOOKUP_END_LOADING";
export const USER_LOOKUP_LOADED = "USER_LOOKUP_LOADED";